import React, { useState, Fragment } from 'react';
import { connect } from "react-redux";
import * as TokenActions from '../token/actions';

import { useDrizzleContext } from "../drizzle/drizzleContext";

import SendPage from './SendPage';

// FIXME I want to introduce "const [ data, setData ] = useState({ to: "", tokenId: "" });".
const SendPageContainer = ({ dispatch, accounts, transactions, transactionStack }) => {
  const drizzle = useDrizzleContext();
  const contract = drizzle.contracts.THDJabraToken;

  const [ data, setData ] = useState({ to: "", tokenId: "" });
  const [ stackId, setStackId ] = useState(null);
  const [ isSendingToken, setIsSendingToken ] = useState(false);

  const handleChangeTo = (e, ref) => {
    const newTokenId = ref.value;

    if (newTokenId !== "") {
      setData({ ...data, [e.target.name]: e.target.value, [ref.name]: ref.value });
    } else {
      setData({...data, [e.target.name]: e.target.value });
    }
  }

  const handleChangeTokenId = e => {
    setData({...data, [e.target.name]: e.target.value });
  }

  const handleSubmit = e => {
    e.preventDefault();
    setValue(data.to, data.tokenId);
    e.target.reset();
    dispatch(updateTokenId()); // FIXME We should watch synced of contracts.
  }

  const setValue = async (_to, _tokenId) => {
    const jabraNumberShift = 8;
    const _jabraNumber = _tokenId % (2 ** jabraNumberShift);
    const _startTime = (_tokenId - (_tokenId % (2 ** jabraNumberShift))) / (2 ** jabraNumberShift);

    const estimatedGas = await contract.methods.sendTokensForPeriod(
        _to, _jabraNumber, _startTime
      ).estimateGas({
        from: accounts[0]
    });

    const estimatedGasPrice = await drizzle.web3.eth.getGasPrice();
    const multiplicationFactor = 1.3;
    const gasPriceMultiplication = 2.4;
    
    const _stackId = await contract.methods["sendTokensForPeriod"].cacheSend(_to, _jabraNumber, _startTime, {
      from: accounts[0],
      gas: Math.floor(estimatedGas*multiplicationFactor),
      gasPrice: Math.floor(estimatedGasPrice*gasPriceMultiplication),
    });
    setStackId(_stackId) ;
    turnSendStatus(true);
  }

  const getTxStatus = () => {
    // get the transaction hash using our saved `stackId`
    const txHash = transactionStack[stackId];

    // if transaction hash does not exist, don't display anything
    if (!txHash) return null;

    if(transactions[txHash]) {
      if (transactions[txHash].status === 'success' && isSendingToken) {
        turnSendStatus(false);
      }

      // otherwise, return the transaction status
      return (
        <Fragment>
          <span>Transaction Status: </span><span className='charcoal'>{transactions[txHash].status}</span>
        </Fragment>
      );
    }
    return (transactions[txHash] &&
      <Fragment>
        <span>Transaction Status: </span><span className='charcoal'>{transactions[txHash].status}</span>
      </Fragment>
    );
  }

  const turnSendStatus = (newstate) => {
    setIsSendingToken(newstate);
  }

  return (
    <SendPage
      transactions={transactions}
      transactionStack={transactionStack}
      handleChangeTo={handleChangeTo}
      handleChangeTokenId={handleChangeTokenId}
      handleSubmit={handleSubmit}
      getTxStatus={getTxStatus}
    />
  );
}

const updateTokenId = () => {
  return {
    type: TokenActions.TOKEN_SENT,
    tokenId: ""
  }
}

const mapStateToProps = state => {
  return {
    accounts: state.accounts,
    transactions: state.transactions,
    transactionStack: state.transactionStack,
  };
};

export default connect(mapStateToProps)(SendPageContainer);
